// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonSmallLayout } from '../common/buttons/ButtonSmallLayout';
import { ButtonLargeLayout } from '../common/buttons/ButtonLargeLayout';

const raw = {
  width: 780,
  height: 1280,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'fbef411b-4a1a-4f44-a806-5eccda773f63',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Screen_3',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        DEBUG: true
      },
      stateByName: {}
    },
    {
      id: '377cf766-a074-472e-8401-bd5b587c6a66',
      type: 'Sprite',
      runtimeType: null,
      name: 'circleGlow',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 4,
        y: 4
      },
      angle: 0,
      alpha: 0.3,
      visible: true,
      tint: 16762112,
      blendMode: 4,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Circle_Glow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '2d5d8cd8-6011-431f-a9b0-29a97b1d9ab8',
      type: 'Container',
      runtimeType: null,
      name: 'fireworksYellow1',
      className: '',
      x: -232,
      y: -427,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'e2a93150-34db-4b55-a666-4f6e0a9fe9b0',
      type: 'Container',
      runtimeType: null,
      name: 'fireworksYellow2',
      className: '',
      x: 215,
      y: -413,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'd485911a-2fe0-40d2-bed1-eab8d6e539ea',
      type: 'Container',
      runtimeType: null,
      name: 'fireworksBlue1',
      className: '',
      x: 44,
      y: -510,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '7c1878ce-1af7-46c7-8ac4-06bf0ac05cd7',
      type: 'Container',
      runtimeType: null,
      name: 'fireworksBlue2',
      className: '',
      x: -46,
      y: -467,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '9bb29ffe-9b37-4761-914b-c33a5c55b89e',
      type: 'Sprite',
      runtimeType: null,
      name: 'ribbonRed',
      className: '',
      x: 0,
      y: -370,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ribbon_Red',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '03a849a6-4e1e-407d-8663-1250e0c17ee2',
      type: 'Text',
      runtimeType: null,
      name: 'levelXCompleteText',
      className: '',
      x: 0,
      y: -295,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level <nr> complete!',
      localize: true,
      maxWidth: 500,
      maxHeight: 200,
      maxFontSize: 0,
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '42d150f9-c211-4fd1-b645-47bb54e56266',
      type: 'Container',
      runtimeType: null,
      name: 'rewardsParticles',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'fd13d175-63fa-42ac-9bb9-963804243c50',
      type: 'Text',
      runtimeType: null,
      name: 'rewardsText',
      className: '',
      x: 0,
      y: -150,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Rewards',
      localize: true,
      maxWidth: 500,
      maxHeight: 200,
      maxFontSize: 0,
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '7bab847a-c139-41b7-8411-646a20a5ceec',
      type: 'Container',
      runtimeType: null,
      name: 'rewardsSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '16cae020-f630-4852-bd16-f749ddacec47',
      type: 'Layout',
      runtimeType: null,
      name: 'nextButton',
      className: '',
      path: 'common/buttons/ButtonSmallLayout.ts',
      percentX: 0,
      percentY: 0,
      x: -190,
      y: 460,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        color: 'blue',
        tapSound: 'UI_Button_Click'
      },
      stateByName: {
        noDoubleCoins: {
          x: 0
        }
      }
    },
    {
      id: '905ca284-47b4-49a3-8007-aa7fdb8602ae',
      type: 'Layout',
      runtimeType: null,
      name: 'doubleCoins',
      className: '',
      path: 'common/buttons/ButtonLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 120,
      y: 460,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        color: 'yellow',
        tapSound: 'UI_Button_Click'
      },
      stateByName: {
        noDoubleCoins: {
          visible: false
        }
      }
    },
    {
      id: 'c34b8bab-5d3d-4e75-bd56-b3b6393639f3',
      type: 'Container',
      runtimeType: null,
      name: 'coinParticleSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '21af2aa4-ca00-45cd-b000-5e071b43922f',
      type: 'Container',
      runtimeType: null,
      name: 'coinCounterSlot',
      className: '',
      x: -247,
      y: -584,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '90910c64-dcfa-42f8-8ea3-6c284f583ea0',
      type: 'Container',
      runtimeType: null,
      name: 'piggyBankIconSlot',
      className: 'dynamicProps_SPL',
      x: 300,
      y: -558,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          x: {
            value: 'width * 0.5 - 90'
          }
        }
      },
      stateByName: {}
    },
    {
      id: 'dfedef06-1395-42b1-84c4-b3403a0f8e06',
      type: 'Text',
      runtimeType: null,
      name: 'niceJobText',
      className: 'curvedText_SPL,upperCase_SPL',
      x: 0,
      y: -45,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Nice Job!',
      localize: true,
      maxWidth: 500,
      maxHeight: 80,
      maxFontSize: 0,
      style: {
        fontSize: 72,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x880029',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 500,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: true,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '9bb29ffe-9b37-4761-914b-c33a5c55b89e',
      data: {
        curveRadius: 1100
      },
      stateByName: {}
    },
    {
      id: '38b4dff0-1b03-49f6-a796-036bf771a9e9',
      type: 'Text',
      runtimeType: null,
      name: 'nextText',
      className: '',
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Next',
      localize: true,
      maxWidth: 150,
      maxHeight: 100,
      maxFontSize: 0,
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0x0036f4',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 90,
        dropShadowBlur: 0,
        dropShadowColor: '0036f4',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '16cae020-f630-4852-bd16-f749ddacec47',
      data: undefined,
      stateByName: {}
    },
    {
      id: '8a3da7d3-f6ef-47cd-a604-c40410f0d6b4',
      type: 'Text',
      runtimeType: null,
      name: 'doubleCoinsText',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Double Coins',
      localize: true,
      maxWidth: 250,
      maxHeight: 100,
      maxFontSize: 0,
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '0xa61700',
        strokeThickness: 7,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 50,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '905ca284-47b4-49a3-8007-aa7fdb8602ae',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'f4ffa1f3-6bfa-427f-aad5-0fbf2b023c6d',
      type: 'Sprite',
      runtimeType: null,
      name: 'watchAddIcon',
      className: '',
      x: -155,
      y: -45,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Wtach_Ad_Orange_Icon',
      parent: '905ca284-47b4-49a3-8007-aa7fdb8602ae',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [
    'noDoubleCoins'
  ],
  animations: [
    {
      id: '3705d387-7cbb-4b01-9eb8-0c9364116935',
      name: 'Win_Screen_Appear',
      playingSpeed: 1,
      totalDuration: 1700,
      blocks: [
        {
          id: 'f53584c1-0142-4ecf-bedd-ab2f15af0cc4',
          type: 'Setter',
          name: 'gradientAlpha0',
          track: 0,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'blueGradient',
          disabled: false
        },
        {
          id: '2b538427-9083-479b-9c31-9a443217ff75',
          type: 'Setter',
          name: 'ribbonScale0',
          track: 2,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'ribbonRed',
          disabled: false
        },
        {
          id: '10b48d69-f551-4da7-b7c2-3632edc1685a',
          type: 'Setter',
          name: 'levelTextScale0',
          track: 8,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'levelXCompleteText',
          disabled: false
        },
        {
          id: 'de384e06-28de-4140-869f-835d8fa4d3fd',
          type: 'Setter',
          name: 'nextButtonScale0',
          track: 4,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'nextButton',
          disabled: false
        },
        {
          id: 'e9ade4d4-e705-44cf-9e80-2ae6539872fa',
          type: 'Setter',
          name: 'doubleCoinsScale0',
          track: 6,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'doubleCoins',
          disabled: false
        },
        {
          id: '5f35af87-898a-4e2b-b988-5ac7fb91c5cd',
          type: 'Setter',
          name: 'rewardsTextScale0',
          track: 10,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'rewardsText',
          disabled: false
        },
        {
          id: '552229fb-666c-478e-a414-501a280ad307',
          type: 'Setter',
          name: '',
          track: 0,
          target: {},
          startAt: 0,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '8b5656dc-5e33-4341-a7ed-a9d8558c7f73',
          type: 'Setter',
          name: 'circleGlowAlpha0',
          track: 16,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'circleGlow',
          disabled: false
        },
        {
          id: '66056ef8-71d0-4506-8e28-923866237eee',
          type: 'Setter',
          name: 'piggyBankScale0',
          track: 18,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'piggyBankIconSlot',
          disabled: false
        },
        {
          id: 'c39ed280-d52b-4a53-8612-40139eca3faa',
          type: 'Tween',
          name: 'gradientAlpha',
          duration: 300,
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 10,
          sourceName: 'blueGradient',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '3d8b3640-c208-4621-92fd-ffcdb59fb992',
          type: 'Tween',
          name: 'circleGlowAlpha',
          duration: 300,
          track: 17,
          target: {
            alpha: 0.3
          },
          startAt: 40,
          sourceName: 'circleGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '1946dc12-e9ee-41e6-aa29-8abec80625b2',
          type: 'Tween',
          name: 'doubleCoinsScale',
          duration: 320,
          track: 7,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 40,
          sourceName: 'doubleCoins',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f33624b3-e8d4-43aa-a6e4-9bc945287aa3',
          type: 'Tween',
          name: 'nextButtonScale',
          duration: 320,
          track: 5,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 40,
          sourceName: 'nextButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'd2e68352-3275-4a39-81d5-268be73df3a5',
          type: 'Tween',
          name: 'ribbonScale',
          duration: 320,
          track: 3,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 40,
          sourceName: 'ribbonRed',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '87538048-7a6e-41a5-ba84-6c0e2e1355ad',
          type: 'Tween',
          name: 'levelTextScale',
          duration: 320,
          track: 9,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 60,
          sourceName: 'levelXCompleteText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '54d95c5f-149a-43be-ade4-1ff5bf9d2469',
          type: 'Tween',
          name: 'rewardsTextScale',
          duration: 320,
          track: 11,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 80,
          sourceName: 'rewardsText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '9902d410-73a3-4c13-8f05-cb3560809a3b',
          type: 'Setter',
          name: 'ANIMEVENT_startAppearRewards',
          track: 20,
          target: {},
          startAt: 290,
          sourceName: 'root',
          disabled: false
        },
        {
          id: 'f096eac9-d5cb-46d4-9357-a59271651444',
          type: 'Setter',
          name: 'FXPART_Fireworks_Yellow',
          track: 15,
          target: {},
          startAt: 300,
          sourceName: 'fireworksYellow1',
          disabled: false
        },
        {
          id: '23611e72-a78f-4fb2-846c-9cf0b30e2424',
          type: 'Tween',
          name: 'doubleCoinsScale',
          duration: 170,
          track: 7,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 360,
          sourceName: 'doubleCoinsText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ed47d3f6-e42e-4c4f-be8c-9fc5e41233e4',
          type: 'Tween',
          name: 'nextButtonScale',
          duration: 170,
          track: 5,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 360,
          sourceName: 'nextButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c35f3088-06c2-49a5-98b9-d97466ee347c',
          type: 'Tween',
          name: 'ribbonScale',
          duration: 170,
          track: 3,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 360,
          sourceName: 'ribbonRed',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '874993af-5496-42bf-8159-c93530892953',
          type: 'Tween',
          name: 'levelTextScale',
          duration: 170,
          track: 9,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 380,
          sourceName: 'levelXCompleteText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a2336dd1-92c6-461a-8a53-9511be24a844',
          type: 'Tween',
          name: 'rewardsTextScale',
          duration: 170,
          track: 11,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 400,
          sourceName: 'rewardsText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '6d21356a-b9b6-4e94-b03d-9364b0d6ff80',
          type: 'Setter',
          name: 'FXPART_Fireworks_Blue',
          track: 15,
          target: {},
          startAt: 700,
          sourceName: 'fireworksBlue1',
          disabled: false
        },
        {
          id: 'b37e24b7-5199-41c3-a25a-dedf3350d41a',
          type: 'Setter',
          name: 'FXPART_Fireworks_Yellow',
          track: 15,
          target: {},
          startAt: 1100,
          sourceName: 'fireworksYellow2',
          disabled: false
        },
        {
          id: 'f9505d48-7aee-42bd-936c-86b32c6e2218',
          type: 'Setter',
          name: 'FXPART_Firework_Blue',
          track: 15,
          target: {},
          startAt: 1500,
          sourceName: 'fireworksBlue2',
          disabled: false
        }
      ]
    },
    {
      id: 'd09054ff-7302-4d85-9f06-d3dafefae7aa',
      name: 'Win_Screen_Disappear',
      playingSpeed: 1,
      totalDuration: 500,
      blocks: [
        {
          id: '08b30b1a-af9a-44fe-b987-9604695d9929',
          type: 'Tween',
          name: 'piggyBankScale',
          duration: 150,
          track: 0,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 0,
          sourceName: 'piggyBankIconSlot',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '50d64708-525a-40f0-b7d9-4a396c1136a3',
          type: 'Tween',
          name: 'nextButtonScale',
          duration: 150,
          track: 5,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 0,
          sourceName: 'nextButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ab6f6364-425e-45fe-85fb-7e6dc41b5988',
          type: 'Tween',
          name: 'doubleCoinsScale',
          duration: 150,
          track: 6,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 0,
          sourceName: 'doubleCoins',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '40484492-0df7-4627-92d2-5ee18e8bc0d4',
          type: 'Tween',
          name: 'ribbonRedScale',
          duration: 150,
          track: 1,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 20,
          sourceName: 'ribbonRed',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f39ca9d9-1d6a-41d5-b5c0-88192f3cc463',
          type: 'Tween',
          name: 'levelTextScale',
          duration: 150,
          track: 2,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 40,
          sourceName: 'levelXCompleteText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e2d5d5e0-4dcd-4d4d-8dcd-4c8856dc5d07',
          type: 'Tween',
          name: 'rewardsTextScale',
          duration: 150,
          track: 3,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 60,
          sourceName: 'rewardsText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '66ece5fa-7489-4705-a5d3-049f53f5ba9c',
          type: 'Tween',
          name: 'rewardsSlotScale',
          duration: 150,
          track: 4,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 80,
          sourceName: 'rewardsSlot',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'd81df2e7-4b24-4af2-9110-dc968524d754',
          type: 'Tween',
          name: 'doubleCoinsScale',
          duration: 170,
          track: 6,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 150,
          sourceName: 'doubleCoins',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '049ad6c1-3fb2-4708-8300-28be3781bddb',
          type: 'Tween',
          name: 'nextButtonScale',
          duration: 170,
          track: 5,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 150,
          sourceName: 'nextButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a593cc6f-7c90-44f8-a76a-2bd08a5a2aab',
          type: 'Tween',
          name: 'piggyBankScale',
          duration: 170,
          track: 0,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 150,
          sourceName: 'piggyBankIconSlot',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '716eafae-689a-405c-9dbf-e73b867fcdee',
          type: 'Tween',
          name: 'ribbonRedScale',
          duration: 170,
          track: 1,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 170,
          sourceName: 'ribbonRed',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e3b72ece-451a-4bd9-923c-104ea3aadfef',
          type: 'Tween',
          name: 'circleGlowAlpha',
          duration: 300,
          track: 8,
          target: {
            alpha: 0
          },
          startAt: 180,
          sourceName: 'circleGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c33a5a05-61bc-4fae-99ad-55118a1dd2fa',
          type: 'Tween',
          name: 'levelTextScale',
          duration: 170,
          track: 2,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 190,
          sourceName: 'levelXCompleteText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e2756b9a-6354-49dd-83c4-ed382c6abdbf',
          type: 'Tween',
          name: 'blueGradientAlpha',
          duration: 300,
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 200,
          sourceName: 'blueGradient',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '01657d62-e6dc-4f06-8a56-75ab5d115ce6',
          type: 'Tween',
          name: 'rewardsTextScale',
          duration: 170,
          track: 3,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 210,
          sourceName: 'rewardsText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b1149dfb-de8c-47a9-9df2-0dffec1d85d3',
          type: 'Tween',
          name: 'rewardsSlotScale',
          duration: 170,
          track: 4,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 230,
          sourceName: 'rewardsSlot',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: '6ade54b7-16f9-44f6-8455-57327dc026c2',
      name: 'Hide_Double_Coins',
      playingSpeed: 1,
      totalDuration: 500,
      blocks: [
        {
          id: 'b2472a55-dbd5-4f5a-ab58-9f738607f656',
          type: 'Tween',
          name: 'New_tween',
          duration: 300,
          track: 1,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'doubleCoins',
          easing: 'QuadraticIn',
          disabled: false
        },
        {
          id: '092bd117-1373-4b72-bf61-3291a9750388',
          type: 'Tween',
          name: 'New_tween_1',
          duration: 300,
          track: 2,
          target: {
            x: 0
          },
          startAt: 182,
          sourceName: 'nextButton',
          easing: 'SinusoidalInOut',
          disabled: false
        }
      ]
    },
    {
      id: '4e380f4a-892e-4091-8682-c27fb3a7264f',
      name: 'Apply_Rewards',
      playingSpeed: 1,
      totalDuration: 500,
      blocks: [
        {
          id: '1d702c96-ec87-46f7-846b-33fe7e2e1059',
          type: 'Setter',
          name: 'ANIMEVENT_startRewardCoins',
          track: 1,
          target: {},
          startAt: 0,
          sourceName: 'root',
          disabled: false
        },
        {
          id: 'b1b9a185-1431-4bce-9b1b-e2f9dc620f4d',
          type: 'Tween',
          name: 'nextButtonScaleDown',
          duration: 300,
          track: 3,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'nextButton',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: 'e0797052-1cfc-43ad-addf-882e0604690d',
          type: 'Tween',
          name: 'doubleButtonScaleDown',
          duration: 300,
          track: 2,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'doubleCoins',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: 'f0400bad-bb7f-411e-9c30-19d5bfee802e',
          type: 'Tween',
          name: 'piggyBankScale_copy',
          duration: 320,
          track: 19,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 1,
          sourceName: 'piggyBankIconSlot',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '4928e612-0cbe-4a74-8cc2-a608144d62ec',
          type: 'Setter',
          name: 'ANIMEVENT_startPiggyCoins',
          track: 20,
          target: {},
          startAt: 33,
          sourceName: 'root',
          disabled: false
        },
        {
          id: '5a2abe8f-cee6-4210-9d7c-b58b30a85436',
          type: 'Tween',
          name: 'piggyBankScale_copy_1',
          duration: 150,
          track: 20,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 321,
          sourceName: 'piggyBankIconSlot',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ]
} as const;

export class WinScreenLayout {
  static raw = raw;
  root: Container;
  circleGlow: Sprite;
  fireworksYellow1: Container;
  fireworksYellow2: Container;
  fireworksBlue1: Container;
  fireworksBlue2: Container;
  ribbonRed: Sprite;
  levelXCompleteText: Text;
  rewardsParticles: Container;
  rewardsText: Text;
  rewardsSlot: Container;
  nextButton: ButtonSmallLayout & { data: typeof raw['list'][12]['data'] };
  doubleCoins: ButtonLargeLayout & { data: typeof raw['list'][13]['data'] };
  coinParticleSlot: Container;
  coinCounterSlot: Container;
  piggyBankIconSlot: Container & { data: typeof raw['list'][16]['data'] };
  niceJobText: Text & { data: typeof raw['list'][17]['data'] };
  nextText: Text;
  doubleCoinsText: Text;
  watchAddIcon: Sprite;
  dynamicProps_SPL: (Container & { data: typeof raw['list'][16]['data'] })[];
  curvedText_SPL: (Text & { data: typeof raw['list'][17]['data'] })[];
  upperCase_SPL: (Text & { data: typeof raw['list'][17]['data'] })[];

  mInternalTypes: {
    Raw: typeof raw;
    StateName: 'noDoubleCoins';
    ModelByName: {
      root: typeof raw['list'][0];
      circleGlow: typeof raw['list'][2];
      fireworksYellow1: typeof raw['list'][3];
      fireworksYellow2: typeof raw['list'][4];
      fireworksBlue1: typeof raw['list'][5];
      fireworksBlue2: typeof raw['list'][6];
      ribbonRed: typeof raw['list'][7];
      levelXCompleteText: typeof raw['list'][8];
      rewardsParticles: typeof raw['list'][9];
      rewardsText: typeof raw['list'][10];
      rewardsSlot: typeof raw['list'][11];
      nextButton: typeof raw['list'][12];
      doubleCoins: typeof raw['list'][13];
      coinParticleSlot: typeof raw['list'][14];
      coinCounterSlot: typeof raw['list'][15];
      piggyBankIconSlot: typeof raw['list'][16];
      niceJobText: typeof raw['list'][17];
      nextText: typeof raw['list'][18];
      doubleCoinsText: typeof raw['list'][19];
      watchAddIcon: typeof raw['list'][20];
    };
  };

  constructor() {
    populate(this, raw);
  }
}

export abstract class Win_Screen_Appear {
  Layout: {
    blueGradient: object;
    ribbonRed: object;
    levelXCompleteText: object;
    nextButton: object;
    doubleCoins: object;
    rewardsText: object;
    root: object;
    circleGlow: object;
    piggyBankIconSlot: object;
    fireworksYellow1: object;
    doubleCoinsText: object;
    fireworksBlue1: object;
    fireworksYellow2: object;
    fireworksBlue2: object;
  };

  BlockTypeByName: {
    gradientAlpha0: FlowBlockType.Setter;
    ribbonScale0: FlowBlockType.Setter;
    levelTextScale0: FlowBlockType.Setter;
    nextButtonScale0: FlowBlockType.Setter;
    doubleCoinsScale0: FlowBlockType.Setter;
    rewardsTextScale0: FlowBlockType.Setter;
    circleGlowAlpha0: FlowBlockType.Setter;
    piggyBankScale0: FlowBlockType.Setter;
    gradientAlpha: FlowBlockType.Tween;
    circleGlowAlpha: FlowBlockType.Tween;
    doubleCoinsScale: FlowBlockType.Tween;
    nextButtonScale: FlowBlockType.Tween;
    ribbonScale: FlowBlockType.Tween;
    levelTextScale: FlowBlockType.Tween;
    rewardsTextScale: FlowBlockType.Tween;
    ANIMEVENT_startAppearRewards: FlowBlockType.Setter;
    FXPART_Fireworks_Yellow: FlowBlockType.Setter;
    doubleCoinsScale: FlowBlockType.Tween;
    nextButtonScale: FlowBlockType.Tween;
    ribbonScale: FlowBlockType.Tween;
    levelTextScale: FlowBlockType.Tween;
    rewardsTextScale: FlowBlockType.Tween;
    FXPART_Fireworks_Blue: FlowBlockType.Setter;
    FXPART_Fireworks_Yellow: FlowBlockType.Setter;
    FXPART_Firework_Blue: FlowBlockType.Setter;
  };

  flowData = raw.animations[0];
}

export abstract class Win_Screen_Disappear {
  Layout: {
    piggyBankIconSlot: object;
    nextButton: object;
    doubleCoins: object;
    ribbonRed: object;
    levelXCompleteText: object;
    rewardsText: object;
    rewardsSlot: object;
    circleGlow: object;
    blueGradient: object;
  };

  BlockTypeByName: {
    piggyBankScale: FlowBlockType.Tween;
    nextButtonScale: FlowBlockType.Tween;
    doubleCoinsScale: FlowBlockType.Tween;
    ribbonRedScale: FlowBlockType.Tween;
    levelTextScale: FlowBlockType.Tween;
    rewardsTextScale: FlowBlockType.Tween;
    rewardsSlotScale: FlowBlockType.Tween;
    doubleCoinsScale: FlowBlockType.Tween;
    nextButtonScale: FlowBlockType.Tween;
    piggyBankScale: FlowBlockType.Tween;
    ribbonRedScale: FlowBlockType.Tween;
    circleGlowAlpha: FlowBlockType.Tween;
    levelTextScale: FlowBlockType.Tween;
    blueGradientAlpha: FlowBlockType.Tween;
    rewardsTextScale: FlowBlockType.Tween;
    rewardsSlotScale: FlowBlockType.Tween;
  };

  flowData = raw.animations[1];
}

export abstract class Hide_Double_Coins {
  Layout: {
    doubleCoins: object;
    nextButton: object;
  };

  BlockTypeByName: {
    New_tween: FlowBlockType.Tween;
    New_tween_1: FlowBlockType.Tween;
  };

  flowData = raw.animations[2];
}

export abstract class Apply_Rewards {
  Layout: {
    root: object;
    nextButton: object;
    doubleCoins: object;
    piggyBankIconSlot: object;
  };

  BlockTypeByName: {
    ANIMEVENT_startRewardCoins: FlowBlockType.Setter;
    nextButtonScaleDown: FlowBlockType.Tween;
    doubleButtonScaleDown: FlowBlockType.Tween;
    piggyBankScale_copy: FlowBlockType.Tween;
    ANIMEVENT_startPiggyCoins: FlowBlockType.Setter;
    piggyBankScale_copy_1: FlowBlockType.Tween;
  };

  flowData = raw.animations[3];
}
